import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

/*
 * Confirms a move of a tree node from its original parent to be under another parent
 * Input: title - confirm dialog's title
 *        moveName - name of the node being moved
 *        moveToName - name of the new parent node
 *-----------------------------------------------------------------------------------
 */
@Component({
  selector: 'ndms-confirm-move',
  templateUrl: './confirm-move.component.html',
  styleUrls: ['./confirm-move.component.css']
})
export class ConfirmMoveComponent implements OnInit {

  @Input() title: string;
  @Input() moveName: string;
  @Input() moveToName: string;
  @Output() confirm: EventEmitter<boolean>= new EventEmitter();
  
  constructor() { }

  ngOnInit() {
    
  }
  onYesClick() {
    this.confirm.emit(true);
  }
  onNoClick() {
    this.confirm.emit(false);
  }
}